export enum ServiceableStatu {
  None = 0,
  NotShippedYet = 1,
  Offered = 2,
  Accepted = 3,
  Rejected = 4,
  OpenedAfterRejection = 99,
}

export enum ServiceableStatuText {
  None = "None",
  NotShippedYet = "NOT SHIPPED YET",
  Offered = "OFFERED",
  Accepted = "ACCEPTED",
  Rejected = "REJECTED",
  OpenedAfterRejection = "OPENED AFTER REJECTION",
}

export const GetServiceableStatus = [
  { Description: "NONE", Value: ServiceableStatu.None },
  { Description: "NOT SHIPPED YET", Value: ServiceableStatu.NotShippedYet },
  { Description: "OFFERED", Value: ServiceableStatu.Offered },
  { Description: "ACCEPTED", Value: ServiceableStatu.Accepted },
  { Description: "REJECTED", Value: ServiceableStatu.Rejected },
  { Description: "OPENED AFTER REJECTION", Value: ServiceableStatu.OpenedAfterRejection },
];
